export default "__VITE_ASSET__D8VdyW10__";